export default __webpack_public_path__ + "static/N0172-b66674d536d843cf75c3014ce07f10f7.png";